import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { NavButtonBar } from './nav-button-bar';

export { NavButton } from './nav-button-bar';


export class NavButtonBarModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NavButtonBarModule, providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  exports: [
    NavButtonBar
  ],
  declarations: [
    NavButtonBar
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
